// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  gridList: {
    paddingBottom: theme.spacing(3),
    display: 'grid',
    // As many columns as fit rather than always three, matching the dashboard.
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gridGap: 30,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(5),
  },
  // The list view's stacked rows, as on the dashboard.
  rowList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(5),
    paddingBottom: theme.spacing(3),
  },
  searchRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '19px',
    marginTop: theme.spacing(2),
  },
  searchField: {
    flex: 1,
    minWidth: 0,
  },
  mapviewLayoutLeft: {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  breadcrumbsContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  circularProgressContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(5),
  },
  noProjectsContainer: {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  },
  // The dashboard's not-found message, at the dashboard's position.
  notFound: {
    width: '100%',
    textAlign: 'center',
    marginTop: '20vh',
  },
  projectsContainer: {
    height: 'calc(100vh - 13rem)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addProjectsButton: {
    marginLeft: 'auto',
  },
  noProjectsIcon: {
    width: 55,
    height: 55,
    color: '#788898',
  },
  noProjectsTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default styles;
